module.exports = __webpack_public_path__ + "static/media/sparkitechsTextImage.1ea5ea26.png";